// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.canvasStyle {
  width: 300px;
  height: 300px;
  border-radius: 50%;
}

/* spinner style */
.spinner {
  position: relative;
  width: 330px;
  height: 330px;
}
.spinner:before, .spinner:after {
  content: "";
  display: block;
  position: absolute;
  border-width: 4px;
  border-style: solid;
  border-radius: 50%;
}

/* spinner-1 styles */
@keyframes rotate-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes anti-rotate-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.spinner.spinner-1:before {
  width: 322px;
  height: 322px;
  border-bottom-color: #6e0909;
  border-right-color: #6e0909;
  border-top-color: rgba(110, 9, 9, 0);
  border-left-color: rgba(110, 9, 9, 0);
  top: 0px;
  left: 0px;
  animation: rotate-animation 4s linear 0s infinite;
}
.spinner.spinner-1:after {
  width: 299.46px;
  height: 299.46px;
  border-bottom-color: #6e0909;
  border-right-color: #6e0909;
  border-top-color: rgba(110, 9, 9, 0);
  border-left-color: rgba(110, 9, 9, 0);
  top: 11.27px;
  left: 11.27px;
  animation: anti-rotate-animation 4s linear 0s infinite;
}

@media only screen and (max-width: 599px) {
  .canvasStyle {
    width: 240px;
    height: 240px;
    border-radius: 50%;
  }
  /* spinner style */
  .spinner {
    position: relative;
    width: 260px;
    height: 260px;
  }
  .spinner:before, .spinner:after {
    content: "";
    display: block;
    position: absolute;
    border-width: 4px;
    border-style: solid;
    border-radius: 50%;
  }
  /* spinner-1 styles */
  @keyframes rotate-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  @keyframes anti-rotate-animation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(-360deg);
    }
  }
  .spinner.spinner-1:before {
    width: 252px;
    height: 252px;
    border-bottom-color: #6e0909;
    border-right-color: #6e0909;
    border-top-color: rgba(110, 9, 9, 0);
    border-left-color: rgba(110, 9, 9, 0);
    top: 0px;
    left: 0px;
    animation: rotate-animation 1s linear 0s infinite;
  }
  .spinner.spinner-1:after {
    width: 234.36px;
    height: 234.36px;
    border-bottom-color: #6e0909;
    border-right-color: #6e0909;
    border-top-color: rgba(110, 9, 9, 0);
    border-left-color: rgba(110, 9, 9, 0);
    top: 8.82px;
    left: 8.82px;
    animation: anti-rotate-animation 10s linear 0s infinite;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/core/components/scanner/web-cam-scanner/web-cam-scanner.component.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AACJ;;AAcA,kBAAA;AACA;EACI,kBAAA;EACA,YAXuB;EAYvB,aAZuB;AAC3B;AAaI;EAEE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAZN;;AAgBA,qBAAA;AAGI;EACA;IACE,uBAAA;EAfJ;EAkBE;IACE,yBAAA;EAhBJ;AACF;AAmBE;EACE;IACE,uBAAA;EAjBJ;EAoBE;IACE,0BAAA;EAlBJ;AACF;AAqBE;EACE,YAhDsB;EAiDtB,aAjDsB;EAkDtB,4BArDe;EAsDf,2BAtDe;EAuDf,oCAAA;EACA,qCAAA;EACA,QAAA;EACA,SAAA;EACA,iDAAA;AAnBJ;AAsBE;EACE,eA3DuB;EA4DvB,gBA5DuB;EA6DvB,4BAjEe;EAkEf,2BAlEe;EAmEf,oCAAA;EACA,qCAAA;EACA,YAAA;EACA,aAAA;EACA,sDAAA;AApBJ;;AAwBA;EACI;IACI,YAAA;IACA,aAAA;IACA,kBAAA;EArBN;EAwBE,kBAAA;EACA;IACI,kBAAA;IACA,YA/EwB;IAgFxB,aAhFwB;EA0D9B;EAwBM;IAEA,WAAA;IACA,cAAA;IACA,kBAAA;IACA,iBAAA;IACA,mBAAA;IACA,kBAAA;EAvBN;EA2BE,qBAAA;EAGI;IACI;MACA,uBAAA;IA3BR;IA8BQ;MACA,yBAAA;IA5BR;EACF;EA+BM;IACI;MACA,uBAAA;IA7BR;IAgCQ;MACA,0BAAA;IA9BR;EACF;EAiCM;IACI,YApHmB;IAqHnB,aArHmB;IAsHnB,4BA7HO;IA8HP,2BA9HO;IA+HP,oCAAA;IACA,qCAAA;IACA,QAAA;IACA,SAAA;IACA,iDAAA;EA/BV;EAkCM;IACI,eA/HoB;IAgIpB,gBAhIoB;IAiIpB,4BAzIO;IA0IP,2BA1IO;IA2IP,oCAAA;IACA,qCAAA;IACA,WAAA;IACA,YAAA;IACA,uDAAA;EAhCV;AACF","sourcesContent":[".canvasStyle{\r\n    width: 300px; \r\n    height: 300px;\r\n    border-radius: 50%;\r\n}\r\n\r\n//animation variables\r\n$bg-color: #fff; //container background-color;\r\n$basic-dark-color: #6e0909; //color of the spinner\r\n$border-width: 4px; //width of spinners border\r\n$basic-spinner-dimensions: 330px; //width and height of spinner\r\n$main-spinner-dimensions: $basic-spinner-dimensions - $border-width * 2; //width and height of bigger circle\r\n$small-spinner-dimensions: $main-spinner-dimensions * .93; //width and height of smaller circle\r\n\r\n$basic-tiny-spinner-dimensions: 260px; //width and height of spinner\r\n$main-tiny-spinner-dimensions: $basic-tiny-spinner-dimensions - $border-width * 2; //width and height of bigger circle\r\n$small-tiny-spinner-dimensions: $main-tiny-spinner-dimensions * .93; //width and height of smaller circle\r\n\r\n/* spinner style */\r\n.spinner {\r\n    position: relative;\r\n    width: $basic-spinner-dimensions;\r\n    height: $basic-spinner-dimensions;\r\n\r\n    &:before,\r\n    &:after {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      border-width: 4px;\r\n      border-style: solid;\r\n      border-radius: 50%;\r\n    }\r\n}\r\n\r\n/* spinner-1 styles */\r\n.spinner.spinner-1 {\r\n  \r\n    @keyframes rotate-animation {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      transform: rotate(360deg);\r\n    }\r\n  }\r\n\r\n  @keyframes anti-rotate-animation {\r\n    0% {\r\n      transform: rotate(0deg);\r\n    }\r\n\r\n    100% {\r\n      transform: rotate(-360deg);\r\n    }\r\n  }\r\n  \r\n  &:before {\r\n    width: $main-spinner-dimensions;\r\n    height: $main-spinner-dimensions;\r\n    border-bottom-color: $basic-dark-color;\r\n    border-right-color: $basic-dark-color;\r\n    border-top-color: rgba($basic-dark-color, 0);\r\n    border-left-color: rgba($basic-dark-color, 0);\r\n    top: 0px;\r\n    left: 0px;\r\n    animation: rotate-animation 4s linear 0s infinite;\r\n  }\r\n  \r\n  &:after {\r\n    width: $small-spinner-dimensions;\r\n    height: $small-spinner-dimensions;\r\n    border-bottom-color: $basic-dark-color;\r\n    border-right-color: $basic-dark-color;\r\n    border-top-color: rgba($basic-dark-color, 0);\r\n    border-left-color: rgba($basic-dark-color, 0);\r\n    top: calc(($main-spinner-dimensions - $small-spinner-dimensions) / 2);\r\n    left: calc(($main-spinner-dimensions - $small-spinner-dimensions) / 2);\r\n    animation: anti-rotate-animation 4s linear 0s infinite;\r\n  }\r\n}\r\n\r\n@media only screen and (max-width: 599px) {\r\n    .canvasStyle{\r\n        width: 240px; \r\n        height: 240px;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    /* spinner style */\r\n    .spinner {\r\n        position: relative;\r\n        width: $basic-tiny-spinner-dimensions;\r\n        height: $basic-tiny-spinner-dimensions;\r\n\r\n        &:before,\r\n        &:after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        border-width: 4px;\r\n        border-style: solid;\r\n        border-radius: 50%;\r\n        }\r\n    }\r\n\r\n    /* spinner-1 styles */\r\n    .spinner.spinner-1 {\r\n    \r\n        @keyframes rotate-animation {\r\n            0% {\r\n            transform: rotate(0deg);\r\n            }\r\n\r\n            100% {\r\n            transform: rotate(360deg);\r\n            }\r\n        }\r\n\r\n        @keyframes anti-rotate-animation {\r\n            0% {\r\n            transform: rotate(0deg);\r\n            }\r\n\r\n            100% {\r\n            transform: rotate(-360deg);\r\n            }\r\n        }\r\n        \r\n        &:before {\r\n            width: $main-tiny-spinner-dimensions;\r\n            height: $main-tiny-spinner-dimensions;\r\n            border-bottom-color: $basic-dark-color;\r\n            border-right-color: $basic-dark-color;\r\n            border-top-color: rgba($basic-dark-color, 0);\r\n            border-left-color: rgba($basic-dark-color, 0);\r\n            top: 0px;\r\n            left: 0px;\r\n            animation: rotate-animation 1s linear 0s infinite;\r\n        }\r\n        \r\n        &:after {\r\n            width: $small-tiny-spinner-dimensions;\r\n            height: $small-tiny-spinner-dimensions;\r\n            border-bottom-color: $basic-dark-color;\r\n            border-right-color: $basic-dark-color;\r\n            border-top-color: rgba($basic-dark-color, 0);\r\n            border-left-color: rgba($basic-dark-color, 0);\r\n            top: calc(($main-tiny-spinner-dimensions - $small-tiny-spinner-dimensions) / 2);\r\n            left: calc(($main-tiny-spinner-dimensions - $small-tiny-spinner-dimensions) / 2);\r\n            animation: anti-rotate-animation 10s linear 0s infinite;\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
